import { useCallback } from "react";
import { useSnackbar } from "notistack";

export type ProfileResponseValue = {
  value?: string | number | boolean | null;
  values?: string | boolean | null;
  "YYYY-MM-DD_value"?: string | null;
  closest_value?: string | null;
  closest_values?: string[] | null;
  correct_value?: string | null;
  integer_value?: number | null;
  float_value?: number | null;
  raw?: string | null;
};

export type SingleResponseJson = {
  [key: string]: ProfileResponseValue | string | null;
};

export type MultiResponseJson = {
  items: SingleResponseJson[];
};

export type JsonParseResult = MultiResponseJson | SingleResponseJson | undefined;

export function isMultiResponse(json: JsonParseResult): json is MultiResponseJson {
  if (json === undefined) return false;
  return (json as MultiResponseJson).items !== undefined;
}

// For situations where not parsing cleanly is OK, e.g. typing in the raw JSON textarea
export function useSafeTestJsonParser(): (value: string) => JsonParseResult {
  const parser = useCallback((value: string) => {
    try {
      return JSON.parse(value);
    } catch (err) {
      return undefined;
    }
  }, []);

  return parser;
}

export function useTestJsonParser(): (value: string) => JsonParseResult {
  const { enqueueSnackbar } = useSnackbar();

  const parser = useCallback(
    (value: string) => {
      try {
        return JSON.parse(value);
      } catch (err) {
        enqueueSnackbar(`Invalid JSON: ${err}`, { variant: "error" });
      }
    },
    [enqueueSnackbar]
  );

  return parser;
}
